// Italian language pack
// Note: All keys are in Simplified Chinese, values are in Italian
// This design allows developers to use Chinese directly as keys for better understanding and maintenance

export default {
  // Computing Application Page - Computing.vue
  computing: {
    // Page titles and basic information
    '平台资产': 'Attivo',
    '质押金额': 'Importo Hashrate',
    '算力周期': 'Periodo di Calcolo',
    '天': 'Giorni',
    '算力类型': 'Tipo di Potenza di Calcolo',
    '基础算力': 'Computing Base',
    '高级算力': 'Computing Avanzato',
    '超级算力': 'Super Computing',
    '企业算力': 'Computing Enterprise',
    '高性能': 'Alte Prestazioni',
    '标准': 'Standard',
    '经济型': 'Economico',
    '申请算力': 'Richiedi Computing',
    '申请解押': 'Riscatto Hashrate',
    '可申请次数': 'Applicazioni Disponibili',
    '剩余次数': 'Volte Rimanenti',
    '短算力类型': 'Tipo',
    '短算力周期': 'Periodo',
    '短预计日收益': 'Giornal.',
    '短剩余次数': 'Restanti',
    '短解押记录': 'Riscatto',
    '短算力记录': 'Leasing',
    '短质押明细': 'Hashrate',
    '短待审': 'Attesa',
    '短成功': 'OK',
    '短失败': 'KO',
    '短完成': 'Fine',
    '超级算力申请': 'Leasing Hashrate',

    '步骤提示租赁': 'Passo 1 Seleziona un piano hashrate · Passo 2 Tocca "Leasing Hashrate"',
    '请选择算力方案': 'Seleziona un piano hashrate',
    '请先选择算力方案': 'Seleziona prima un piano hashrate, poi tocca leasing',    '算力收益等级': 'Livelli di Rendimento Computing',
    '查看算力收益等级': 'Visualizza Livelli di Rendimento',
    '暂无高级算力等级数据': 'Nessun dato sui livelli di computing avanzato disponibile',
    '暂无超级算力等级数据': 'Nessun dato sui livelli di super computing disponibile',

    // Pagina Dettagli Applicazione Computing
    '算力详情': 'Dettagli Computing',
    '基本信息': 'Informazioni di Base',
    '原押金额': 'Importo Puntata Originale',
    '每日收益记录': 'Registri Guadagni Giornalieri',
    '暂无数据': 'Nessun Dato Disponibile',

    // Computing details
    '算力类型标签': 'Tipo:',
    '算力周期标签': 'Periodo:',
    '算力类型：': 'Tipo:',
    '算力周期：': 'Periodo:',
    '预计收益：': 'Guadagni:',
    '质押要求：': 'Puntata:',
    '开始时间：': 'Inizio:',
    '结束时间：': 'Fine:',
    '立即申请': 'Applica',

    // Status and prompts
    '申请中': 'In corso...',
    '申请中...': 'Caricamento...',
    '申请成功': 'Riuscito',
    '申请失败': 'Fallito',
    '申请失败，请重试': 'Applicazione fallita, riprova',
    '余额不足': 'Saldo Insufficiente',
    '请先连接钱包': 'Collega Portafoglio',
    '算力申请成功！': 'Computing riuscito!',
    '算力申请失败，请重试': 'Computing fallito, riprova',
    '申请失败，请先解押已完成的算力订单': 'Richiesta fallita, sblocca prima l\'ordine di potenza di calcolo completato',
    
    // Confirmation dialog
    '确认申请': 'Conferma Applicazione',
    '取消': 'Annulla',
    '确认': 'Conferma',
    '您确定要申请此算力吗': 'Richiedere questo computing?',
    '您确定要申请此算力吗？': 'Richiedere questo computing?',
    '申请后将扣除相应的质押金额': 'L\'importo sarà detratto',
    
    // Computing status
    '运行中': 'In Esecuzione',
    '已完成': 'Completato',
    '待开始': 'In Attesa',
    '已取消': 'Annullato',
    
    // Earnings related
    'USDC': 'USDC',
    '预计日收益': 'Guadagni Giornalieri Previsti',
    '总预计收益': 'Guadagni Totali Previsti',
    '当前收益': 'Guadagni Attuali',
    
    // Records and status
    '解押申请记录': 'Record Riscatto',
    '超级算力申请记录': 'Log Potenza',
    '全部': 'Tutti',
    '待审核': 'In Attesa',
    '成功': 'Successo',
    '失败': 'Fallito',
    '正在加载记录': 'Caricamento registri...',
    '暂无记录': 'Nessun registro',
    '解押金额': 'Importo Riscatto',
    '申请天数': 'Giorni di Richiesta',
    '金额': 'Importo',

    // Modal related
    '选择周期': 'Periodo Selezionato',
    '收益率': 'Tasso di Rendimento',
    '申请金额': 'Importo della Richiesta',
    '请输入申请金额': 'Si prega di inserire l\'importo della richiesta',
    '最大可申请金额': 'Importo massimo applicabile',
    '投入限额': 'Limite di Investimento',
    '最低投入': 'Investimento Minimo',
    '最大投入': 'Investimento Massimo',
    '短投入限额': 'Limite',
    '请输入有效的申请金额': 'Si prega di inserire un importo di richiesta valido',
    '申请金额不能低于最低投入': 'L\'importo della richiesta non può essere inferiore all\'investimento minimo',
    '申请金额不能高于最大投入': 'L\'importo della richiesta non può superare l\'investimento massimo',
    '提交中': 'Invio in corso...',

    // Error messages
    '网络错误，请稍后重试': 'Errore di rete, riprova più tardi',
    '参数错误': 'Errore di parametro',
    '服务器错误': 'Errore del server',
    '未知错误': 'Errore sconosciuto',
    '请输入有效金额': 'Si prega di inserire un importo valido',
    '请输入大于0的解押金额': 'Si prega di inserire un importo di rilascio maggiore di 0',
    '申请提交成功': 'Richiesta inviata con successo',
    '您的解押申请已提交，请等待审核': 'La tua richiesta di rilascio è stata inviata, attendi la revisione',
    '申请提交失败': 'Invio della richiesta fallito',
    '请稍后重试': 'Riprova più tardi',
    '您的账户余额不足，无法申请算力': 'Il saldo del tuo account è insufficiente per richiedere potenza di calcolo',
    '您的算力申请已提交，请等待审核': 'La tua richiesta di potenza di calcolo è stata inviata, attendi la revisione',
    '登录已过期': 'Accesso scaduto',
    '请重新连接钱包': 'Si prega di riconnettere il portafoglio',
    '加载失败': 'Caricamento fallito',
    '无法获取解押申请记录': 'Impossibile ottenere i registri di richiesta di rilascio',
    '您还有待审核的申请，请等待审核完成后再提交新申请': 'Hai una richiesta in sospeso, attendi il completamento della revisione prima di inviare una nuova richiesta',
    '您还有未解押的算力订单，无法申请新的算力': 'Hai un ordine di potenza di calcolo non rilasciato, non puoi richiedere una nuova potenza di calcolo',
    '申请次数已用完，最大申请次数': 'Limite di richieste raggiunto',
    '没有可解押的金额': 'Nessun importo disponibile per il rilascio',
    '您已有待处理的解押申请，请等待审核': 'Hai già una richiesta di rilascio in sospeso, attendi la revisione',

    '我的算力订单': 'I Miei Ordini Hashrate',
    '总质押': 'Totale in Staking',
    '总收益': 'Guadagno Totale',
    '进行中': 'Attivo',
    '剩余天数': 'Giorni Restanti',
    '暂无算力订单': 'Nessun ordine hashrate',

    // Popup relativi alla connessione del portafoglio
    '钱包未连接': 'Portafoglio non collegato',
    '钱包信息错误': 'Errore informazioni portafoglio',
    '钱包地址无效': 'Indirizzo portafoglio non valido',
    '授权已失效': 'Autorizzazione scaduta',
    '授权检查失败': 'Verifica autorizzazione fallita',
    '请重新授权USDC后再进行投资': 'Si prega di riautorizzare USDC prima di investire',
    '请稍后重试或重新连接钱包': 'Riprova più tardi o riconnetti il portafoglio',
    '断开连接': 'Disconnetti',
    '质押金额不足': 'Importo puntato insufficiente',
    '解押金额不能超过当前质押金额': 'L\'importo di rilascio non può superare l\'importo puntato attuale',
    '需要连接钱包才能申请算力': 'È necessario collegare il portafoglio per richiedere potenza di calcolo',
    '需要连接钱包才能申请解押': 'È necessario collegare il portafoglio per richiedere il rilascio',

    // Mappatura testo stato
    '状态待审核': 'In Attesa',
    '状态成功': 'Successo',
    '状态失败': 'Fallito',
    '状态进行中': 'In Corso',
    '状态已完成': 'Completato',
    '状态已取消': 'Annullato',
    '状态未知': 'Sconosciuto',

    // Relativo all\'indirizzo del portafoglio
    '未连接钱包': 'Portafoglio non collegato',
    '地址格式错误': 'Formato indirizzo non valido',

    // Servizio clienti
    '客服功能开发中，敬请期待': 'Il servizio clienti è in sviluppo, rimanete sintonizzati!',

    // Relativo alle impostazioni di potenza di calcolo
    '设置错误': 'Errore impostazioni',
    '未找到对应的算力设置': 'Impostazioni potenza di calcolo non trovate',
    '无法获取算力设置': 'Impossibile ottenere le impostazioni di potenza di calcolo',

    // Relativo allo sblocco (nuovo)
    '解押审核中': 'Sblocco in Revisione',
    '已解押': 'Sbloccato',
    '确认解押': 'Conferma Sblocco',
    '处理中': 'Elaborazione...',
    '解押申请已提交': 'Richiesta di Sblocco Inviata',
    '请等待审核处理': 'Si prega di attendere la revisione',
    '解押申请失败': 'Richiesta di Sblocco Fallita',
    '当前状态不允许解押': 'Lo stato attuale non consente lo sblocco',

    // Relativo ai dettagli di garanzia (nuovo)
    '质押明细': 'Dettagli Hashrate',
    '后值': 'Valore Successivo',
    '管理员操作': 'Operazione Sistema',
    '暂无质押记录': 'Nessun record hashrate',
    '正在加载质押记录': 'Caricamento record hashrate...',
    '获取质押记录失败': 'Impossibile ottenere i record hashrate',
    '收益': 'Guadagni',
    '质押': 'Hashrate',
    '解押': 'Riscatto',
    '充值': 'Deposito',
    '提现': 'Prelievo',
    '奖励': 'Ricompensa',
    '推荐奖励': 'Ricompensa Referral',
    '系统调整': 'Aggiustamento Sistema',
    '算力收益': 'Guadagni Computazionali',
    '机器人收益': 'Guadagni Bot',

    // Messaggi di caricamento e errore (nuovo)
    '无法获取申请详情': 'Impossibile ottenere i dettagli della richiesta',
    '请检查网络连接后重试': 'Si prega di controllare la connessione di rete e riprovare',
    '未找到可解押的算力申请': 'Nessuna richiesta di potenza di calcolo sbloccabile trovata',

    // Relativo allo stato (nuovo)

    // Relativo alla pagina dei dettagli (nuovo)
    '算力申请详情': 'Dettagli della Richiesta di Potenza di Calcolo',
    '算力申请记录': 'Registri delle Richieste di Potenza di Calcolo',
    '正在加载详情': 'Caricamento dettagli...',
    '申请周期': 'Periodo della Richiesta',
    '申请时间': 'Tempo di Richiesta',
    '累计收益': 'Guadagni Totali',
    '暂无收益记录': 'Nessun registro di guadagni',
    '加载失败请重试': 'Caricamento fallito, si prega di riprovare',
    '重新加载': 'Ricarica',
    '包含累计收益': 'inclusi i guadagni totali',
    '解押后资金将退回到平台资产中不再产生收益': 'Dopo lo sblocco, i fondi saranno restituiti agli asset della piattaforma e non genereranno più guadagni.',
    '申请赎回': 'Riscatta Hashrate',
    '赎回金额': 'Importo Riscatto',
    '赎回审核中': 'Riscatto in Revisione',
    '未到期不可赎回': 'Non riscattabile prima della scadenza',
    '暂不可赎回': 'Non Ancora Riscattabile',
    '当前算力未到期': 'L\'hashrate corrente non è scaduto, il riscatto sarà disponibile dopo la scadenza',
    '需要连接钱包才能申请赎回': 'È necessario collegare il wallet per richiedere il riscatto',
    '您的赎回申请已提交，请等待审核': 'La tua richiesta di riscatto è stata inviata, attendi la revisione',
    '确认赎回': 'Conferma riscatto',
    '已赎回': 'Riscattato',
    '您已有待处理的赎回申请，请等待审核': 'Hai già una richiesta di riscatto in sospeso, attendi la revisione',
    '当前状态不允许赎回': 'Lo stato attuale non consente il riscatto',
    '没有可赎回的金额': 'Nessun importo riscattabile disponibile'
  },

  // ==================== Pagina Patrimonio - Assets.vue ====================
  assets: {
    // Patrimonio totale
    '总资产': 'Patrimonio Totale',
    '复制成功': 'Copiato con successo',
    '我的余额(元)': 'Il Mio Saldo (Yuan)',

    // Panoramica dei redditi
    '总收入': 'Reddito Totale',
    '今日收入': 'Reddito di Oggi',
    '今日收益': 'Guadagni di Oggi',
    '昨日收益': 'Guadagni di Ieri',
    '体验金': 'Saldo Demo',
    '空投奖励': 'lancio aereo',

    // Pulsanti di azione
    '充值': 'Deposito',
    '快速充值说明': 'Deposita USDC rapidamente',
    '提现': 'Prelievo',
    '邀请': 'Invita',
    '白皮书': 'Whitepaper',
    '幸运轮': 'Ruota della Fortuna',
    '站内信': 'Messaggi',
    '信用分': 'Punteggio di Credito',
    '快捷邀请': 'Invita',
    '快捷白皮书': 'Docs',
    '快捷幸运轮': 'Fortuna',
    '快捷信用分': 'Credito',

    // Livello VIP
    'VIP等级': 'Livello VIP',
    '暂无VIP等级数据': 'Nessun dato sul livello VIP disponibile',

    // Il mio account
    '我的账户': 'Il Mio Account',
    '申请备用金': 'Richiedi Fondo di Riserva',
    '设置资金密码': 'Imposta Password Fondi',
    '选择语言': 'Seleziona Lingua',
    '英语': 'Inglese',

    // Messaggi di log della console
    '钱包未连接，触发钱包连接': 'Portafoglio non collegato, attivazione connessione portafoglio',
    '钱包地址无效，重新连接': 'Indirizzo portafoglio non valido, riconnessione',
    '钱包已连接，直接跳转到充值页面': 'Portafoglio collegato, reindirizzamento alla pagina di deposito',
    '检查授权状态失败': 'Verifica dello stato di autorizzazione fallita',
    '白皮书功能': 'Funzione whitepaper',
    '检查资金密码状态失败': 'Verifica dello stato della password fondi fallita',

    // Log relativi all'API
    'Token不存在，显示默认余额': 'Token non esiste, mostrando saldo predefinito',
    '调用API获取用户余额数据': 'Chiamata API per ottenere dati saldo utente...',
    '体验金加载成功': 'Saldo demo caricato con successo',
    '总资产计算完成': 'Calcolo patrimonio totale completato',
    '余额': 'Saldo',
    '质押金额': 'Importo Hashrate',
    'API返回失败': 'API ha restituito fallimento',
    '加载用户余额失败': 'Caricamento saldo utente fallito',
    'Token不存在，显示默认收益': 'Token non esiste, mostrando guadagni predefiniti',
    '调用API获取用户收益数据...': 'Chiamata API per ottenere dati guadagni utente...',
    '收益数据加载成功': 'Dati guadagni caricati con successo',
    '收益API返回失败': 'API guadagni ha restituito fallimento',
    '加载用户收益失败': 'Caricamento guadagni utente fallito',
    '使用默认收益数据': 'Utilizzo dati guadagni predefiniti',
    '信用分加载成功': 'Punteggio di credito caricato con successo',

    // Selezione lingua
    '中文（简体）': 'Cinese (Semplificato)',

    // Ricompense airdrop correlate
    '钱包地址': 'Indirizzo portafoglio',
    '调用API获取空投奖励数据...': '🔍 Chiamata API per ottenere dati ricompense airdrop...',

    // Servizio clienti correlato
    '打开客服': 'Apri servizio clienti',
    '客服功能开发中，敬请期待！': 'Funzione servizio clienti in sviluppo, resta sintonizzato!',

    // Caricamento pagina
    '资产页面已加载': 'Pagina risorse caricata'
  },

  // ==================== Pagina di Ricarica - Recharge.vue ====================
  recharge: {
    // Titolo pagina e navigazione
    '充值': 'Ricarica',
    '返回': 'Indietro',
    '充值记录': 'Cronologia Ricariche',

    // Titoli dei passaggi
    '选择金额': 'Seleziona Importo',
    '确认订单': 'Conferma Ordine',
    '完成转账': 'Completa Trasferimento',

    // Inserimento importo
    '请输入充值金额': 'Inserisci l\'importo di ricarica',
    '自定义': 'Personalizzato',
    '最小充值金额': 'Importo minimo di ricarica',
    '最小充值金额提示': 'Minimo 500 USDC',
    '最大充值金额': 'Importo massimo di ricarica',
    '下一步': 'Avanti',
    '上一步': 'Indietro',
    '开通自动转入': 'Abilita Trasferimento Automatico',

    // Informazioni ordine
    '订单信息': 'Informazioni Ordine',
    '订单号': 'Numero Ordine',
    '充值金额': 'Importo Ricarica',
    '网络': 'Rete',
    '代币': 'Token',
    '收款地址': 'Indirizzo di Ricezione',
    '创建订单': 'Crea Ordine',
    '创建中': 'Creazione...',

    // Connessione portafoglio
    '请先连接钱包': 'Connetti prima il portafoglio',
    '未检测到钱包地址，请先连接钱包': 'Indirizzo portafoglio non rilevato, connetti prima il portafoglio',
    '钱包连接状态异常，请刷新页面后重试': 'Stato connessione portafoglio anomalo, aggiorna la pagina e riprova',
    '检测到钱包已断开连接，请重新连接': 'Rilevata disconnessione portafoglio, riconnetti',

    // Saldo
    'USDC余额不足': 'Saldo USDC insufficiente! Saldo attuale',
    '转账超时，请检查钱包或重试': 'Timeout trasferimento, controlla il portafoglio o riprova',
    '转账成功但没有获得交易哈希，请手动提供交易哈希': 'Trasferimento riuscito ma nessun hash di transazione ricevuto, fornisci manualmente l\'hash di transazione',
    '请先连接MetaMask钱包': 'Connetti prima il portafoglio',
    '转账可能成功但无法获取交易哈希，请手动检查钱包': 'Il trasferimento potrebbe essere riuscito ma non è possibile ottenere l\'hash di transazione, controlla manualmente il portafoglio',
    '交易哈希无效，请稍后在钱包历史中复制正确的交易哈希': 'Hash di transazione non valido, copia l\'hash corretto dalla cronologia del portafoglio più tardi',
    '钱包地址不存在': 'L\'indirizzo del portafoglio non esiste',
    '交易失败': 'Transazione fallita',
    '当前网络': 'Rete attuale',
    '请切换到以太坊主网或测试网': 'Passa alla rete principale Ethereum o testnet',
    '请点击页面右上角网络设置，选择Ethereum，然后重新充值。': 'Fai clic sulle impostazioni di rete nell\'angolo in alto a destra della pagina, seleziona Ethereum, quindi ricarica di nuovo.',
    '需要': 'Richiesto',
    '更新订单失败': 'Aggiornamento ordine fallito',

    // Passaggi trasferimento
    '请使用钱包转账': 'Utilizza il portafoglio per trasferire',
    '转账地址': 'Indirizzo Trasferimento',
    '转账金额': 'Importo Trasferimento',
    '合约地址': 'Indirizzo Contratto',
    '复制地址': 'Copia Indirizzo',
    '复制金额': 'Copia Importo',
    '开始转账': 'Inizia Trasferimento',
    '转账中': 'Trasferimento in corso...',
    '重新转账': 'Riprova Trasferimento',
    '查看详情': 'Vedi Dettagli',

    // Informazioni stato
    '等待转账': 'In attesa di trasferimento',
    '确认中': 'Conferma in corso',
    '转账成功': 'Trasferimento riuscito',
    '转账失败': 'Trasferimento fallito',
    '交易哈希': 'Hash Transazione',
    '在区块链浏览器中查看': 'Visualizza nell\'explorer blockchain',

    // Suggerimenti
    '请确保转账金额准确': 'Assicurati che l\'importo del trasferimento sia accurato',
    '请确保使用正确的网络': 'Assicurati di utilizzare la rete corretta',
    '转账完成后系统会自动确认': 'Il sistema confermerà automaticamente dopo il completamento del trasferimento',
    '地址已复制': 'Indirizzo copiato',
    '金额已复制': 'Importo copiato',
    '复制失败': 'Copia fallita',

    // Messaggi di errore
    '金额不能为空': 'L\'importo non può essere vuoto',
    '金额必须大于': 'L\'importo deve essere maggiore di',
    '金额不能超过': 'L\'importo non può superare',
    '创建订单失败': 'Creazione ordine fallita',
    '转账失败，请重试': 'Trasferimento fallito, riprova',
    '网络错误，请检查连接': 'Errore di rete, controlla la connessione',

    // MetaMask相关
    '请安装MetaMask钱包': 'Installa il portafoglio',
    '网络检查通过': 'Controllo rete superato',
    'USDC余额不足！当前余额': 'Saldo USDC insufficiente! Saldo attuale: {balance} USDC, richiesto: {amount} USDC',
    '余额检查通过': '✅ Controllo saldo superato',
    '余额检查失败': 'Controllo saldo fallito',
    '开始执行转账': '🚀 Inizio esecuzione trasferimento...',
    '请在MetaMask中确认交易': '⏳ Conferma la transazione',
    '最终交易哈希': '✅ Hash transazione finale',
    '交易哈希已保存到数据库': '✅ Hash transazione salvato nel database',
    '保存哈希失败': '❌ Salvataggio hash fallito',
    '转账发送失败': '❌ Invio trasferimento fallito',
    '交易提交超时，请检查钱包交易记录或稍后重试': 'Timeout invio transazione, controlla i record delle transazioni del portafoglio o riprova più tardi',
    'Gas估算失败': 'Stima Gas fallita',
    '交易哈希更新成功': '✅ Hash transazione aggiornato con successo',
    '更新订单交易哈希失败': '❌ Aggiornamento hash transazione ordine fallito',
    '启动交易监控，订单号': '🔄 Avvio monitoraggio transazione, numero ordine',
    '检查交易状态': '🔍 Controllo stato transazione...',
    '订单状态响应': '📊 Risposta stato ordine',
    '订单详情': '📋 Dettagli ordine',
    '交易成功': '✅ Transazione riuscita!',
    '交易还在确认中，状态': '⏳ Transazione ancora in conferma, stato',
    'API响应失败': '❌ Risposta API fallita',
    '检查交易状态失败': 'Controllo stato transazione fallito',
    '转账状态已重置': '🔄 Stato trasferimento ripristinato',

    // Servizio clienti
    '客服功能开发中，敬请期待': 'Funzione servizio clienti in sviluppo, resta sintonizzato!',

    // Livelli di tasso di potenza di calcolo
    '查看算力收益等级': 'Visualizza livelli di tasso di calcolo',
    '算力收益等级': 'Livelli di tasso di potenza di calcolo',
    '暂无算力收益等级数据': 'Nessun dato sui livelli di tasso di calcolo disponibile',
    '获取算力收益等级失败': 'Fallimento nell\'ottenere i livelli di tasso di calcolo',
    '日收益率': 'Tasso giornaliero'
  },

  // ==================== Pagina di Prelievo - Withdrawal.vue ====================
  withdrawal: {
    // Titolo pagina e navigazione
    '提现': 'Prelievo',
    '返回': 'Indietro',
    '提现记录': 'Cronologia Prelievi',

    // Visualizzazione saldo
    '我的提现账户余额': 'Saldo del Mio Conto Prelievi',
    '可提现余额': 'Saldo Disponibile',
    '当前可提取余额': 'Saldo Disponibile Attuale',
    '信用分': 'Credito',

    // Campi modulo
    '提现金额': 'Importo Prelievo',
    '请输入提现金额': 'Inserisci l\'importo del prelievo',
    '请输入自定义提款金额': 'Inserisci un importo personalizzato',
    '最大限度': 'Max',
    '提现地址': 'Indirizzo Prelievo',
    '请输入提现地址': 'Inserisci l\'indirizzo di prelievo',
    '提现密码': 'Password Prelievo',
    '请输入提现密码': 'Inserisci la password di prelievo',
    '资金密码': 'Password Fondi',
    '请输入资金密码': 'Inserisci la password dei fondi',
    '显示密码': 'Mostra Password',
    '隐藏密码': 'Nascondi Password',

    // Regole di prelievo
    '提款规则': 'Regole di Prelievo',
    '提现规则': 'Regole di Prelievo',
    '手续费': 'Commissione',
    '单笔范围': 'Intervallo per operazione',
    '提现手续费': 'Commissione Prelievo',
    '提现金额范围': 'Intervallo Importo Prelievo',
    '资金将在1-24小时内到账': 'I fondi arriveranno entro 1-24 ore',
    '手续费率': 'Tasso Commissione',
    '最小提现金额': 'Prelievo Minimo',
    '最大提现金额': 'Prelievo Massimo',
    '预计到账时间': 'Tempo di Arrivo Previsto',
    '工作日内处理': 'Elaborato nei giorni lavorativi',

    // Pulsanti e azioni
    '确认提款': 'Conferma Prelievo',
    '处理中': 'Elaborazione',
    '提交申请': 'Invia Richiesta',
    '设置资金密码': 'Imposta Password Fondi',
    '忘记密码？': 'Password Dimenticata?',
    '取消': 'Annulla',
    '去设置': 'Vai alle Impostazioni',

    // Prompt modali
    '需要设置资金密码': 'Necessario Impostare Password Fondi',
    '为了您的资金安全，请先设置资金密码': 'Per la sicurezza dei tuoi fondi, imposta prima la password dei fondi',

    // Messaggi di successo
    '申请提交成功': 'Richiesta Inviata con Successo',
    '您的提现申请已提交，请等待审核': 'La tua richiesta di prelievo è stata inviata, attendi la revisione',
    '提现申请已提交': 'Richiesta di prelievo inviata',
    '请等待审核': 'Attendi la revisione',

    // Messaggi di errore
    '申请提交失败': 'Invio Richiesta Fallito',
    '提现申请失败': 'Richiesta di prelievo fallita',
    '请稍后重试': 'Riprova più tardi',
    '余额不足': 'Saldo Insufficiente',
    '金额格式错误': 'Formato importo non valido',
    '地址格式错误': 'Formato indirizzo non valido',
    '资金密码错误': 'Password fondi errata',
    '您还有待处理的提现申请，请等待处理完成后再提交新申请': 'Hai una richiesta di prelievo in sospeso, attendi che venga elaborata prima di inviarne una nuova',
    '信用分不足': 'Punteggio di Credito Insufficiente',
    '信用分不足无法提款': 'Punteggio di credito insufficiente, impossibile prelevare',
    '您有待还款订单，请还款后申请提现': 'Hai ordini di prestito in sospeso. Si prega di rimborsare prima di richiedere un prelievo!',

    // Messaggi di sistema e log
    '用户提现申请': 'Richiesta prelievo utente',
    '加载用户数据失败': 'Caricamento dati utente fallito',
    '检查资金密码状态失败': 'Verifica stato password fondi fallita'
  },

  // ==================== Pagina Cronologia Prelievi - WithdrawalHistory.vue ====================
  withdrawalHistory: {
    // Titolo pagina e navigazione
    '提现记录': 'Cronologia Prelievi',

    // Schede filtro
    '全部': 'Tutti',
    '待审核': 'In Attesa',
    '处理中': 'Elaborazione',
    '已完成': 'Completato',
    '失败': 'Fallito',
    '已取消': 'Annullato',

    // Stati di caricamento
    '正在加载记录': 'Caricamento record',
    '暂无记录': 'Nessun record',

    // Informazioni record
    '链类型': 'Tipo di Catena',
    '提现时间': 'Ora Prelievo',
    '操作时间': 'Ora Operazione',
    '订单号': 'Numero Ordine',
    '提现金额': 'Importo Prelievo',
    '手续费': 'Commissione',
    '实际金额': 'Importo Effettivo',
    '实际到账': 'Ricevuto Effettivo',
    '提现地址': 'Indirizzo Prelievo',
    '转账Hash': 'Hash Trasferimento',
    '交易Hash': 'Hash Transazione',
    '备注': 'Nota',

    // Modal dettagli
    '提现详情': 'Dettagli Prelievo',
    '基本信息': 'Informazioni Base',
    '状态': 'Stato',
    '金额信息': 'Informazioni Importo',
    '地址信息': 'Informazioni Indirizzo',
    '时间信息': 'Informazioni Tempo',
    '处理时间': 'Tempo Elaborazione',

    // Funzionalità copia
    '地址已复制': 'Indirizzo copiato',
    'Hash已复制': 'Hash copiato',
    '复制失败': 'Copia fallita',
    '请手动复制': 'Per favore copia manualmente',

    // Messaggi errore
    '获取提现记录失败': 'Recupero record prelievi fallito',
    '加载提现记录失败': 'Caricamento record prelievi fallito',
    '筛选': 'Filtro',
    '记录数': 'Record',
    '提现总额': 'Totale Prelievo'
  },

  // ==================== Modale Invito - InviteModal.vue ====================
  invite: {
    '邀请好友一起赚币': 'Invita amici a guadagnare insieme',
    '复制邀请码': 'Copia codice invito',
    '朋友扫二维码注册加入': 'Gli amici scansionano il codice QR per registrarsi',
    '邀请链接': 'Link di invito',
    '加载邀请数据失败': 'Errore caricamento dati invito',
    '加载失败': 'Caricamento fallito',
    '获取邀请信息失败，请稍后重试': 'Errore ottenimento info invito, riprova più tardi',
    '生成二维码失败': 'Errore generazione codice QR',
    '邀请码已复制': 'Codice invito copiato',
    '邀请链接已复制': 'Link invito copiato',
    '复制失败': 'Copia fallita',
    '请手动复制': 'Copia manualmente'
  },

  // ==================== Pagina Ruota della Fortuna - LuckyWheel.vue ====================
  luckyWheel: {
    '幸运轮': 'Ruota della Fortuna',
    '页面副标题': 'Griglia premi · sequenza luminosa',
    '剩余': 'Rimanenti',
    '次': 'volte',
    '奖金': 'Premio',
    '抽奖': 'Estrai',
    '奖品': 'Premio',
    '暂无中奖记录': 'Nessun record vincita',
    '总抽奖次数': 'Estrazioni Totali',
    '抽奖次数不足': 'Estrazioni insufficienti',
    '提示': 'Avviso',
    '抽奖失败': 'Estrazione fallita',
    '网络错误': 'Errore di rete',
    '网络错误，请重试': 'Errore di rete, riprova',
    '中奖时间': 'Ora Vincita',
    '中奖金额': 'Importo Vinto',
    '状态': 'Stato',
    '暂无数据': 'Nessun dato',
    '待发放': 'In Attesa',
    '已发放': 'Distribuito',
    '发放失败': 'Fallito',
    '恭喜中奖': 'Congratulazioni!',
    '确定': 'OK',

    // 新增的翻译键 - TopHeader.vue 中的中文文本
    '钱包未连接，请先连接钱包': 'Portafoglio non connesso, si prega di connettere prima il portafoglio',
    '中文（简体）': 'Cinese (Semplificato)',
    '用户取消了授权': 'L\'utente ha annullato l\'autorizzazione',
    'ETH余额不足，无法支付Gas费用': 'Saldo ETH insufficiente, impossibile pagare le commissioni gas',
    'Gas费用设置过低': 'Commissioni gas impostate troppo basse',
    '交易nonce错误，请重试': 'Errore nonce transazione, si prega di riprovare',
    'Gas价格过低，请提高Gas价格': 'Prezzo gas troppo basso, si prega di aumentare il prezzo gas',
    '合约参数错误，请检查网络和合约地址': 'Errore parametro contratto, si prega di verificare rete e indirizzo contratto',
    '余额不足，无法完成授权': 'Saldo insufficiente, impossibile completare l\'autorizzazione',
    '请安装 MetaMask 或其他以太坊钱包': 'Si prega di installare MetaMask o altro portafoglio Ethereum',
    '请安装 TronLink 钱包': 'Si prega di installare il portafoglio TronLink',
    '未找到授权目标地址，请先获取系统配置': 'Indirizzo target autorizzazione non trovato, si prega di ottenere prima la configurazione sistema',
    '获取授权地址失败': 'Fallimento nell\'ottenere l\'indirizzo di autorizzazione',
    '不支持的网络类型': 'Tipo di rete non supportato',
    '网络切换可能未完成，当前链ID': 'Il cambio di rete potrebbe non essere completato, ID catena corrente',
    '请刷新页面重试': 'Si prega di aggiornare la pagina e riprovare',
    '网络连接失败': 'Connessione di rete fallita',
    '授权地址格式错误': 'Formato indirizzo autorizzazione errato',
    '合约地址格式错误': 'Formato indirizzo contratto errato',
    'ETH余额不足！当前余额': 'Saldo ETH insufficiente! Saldo corrente',
    '需要': 'Richiesto',
    '钱包连接请求正在等待处理，请在MetaMask中确认': 'Richiesta connessione portafoglio in attesa, si prega di confermare in MetaMask',
    '钱包连接请求正在等待处理，请在Trust Wallet中确认': 'Richiesta connessione portafoglio in attesa, si prega di confermare in Trust Wallet',
    '钱包连接请求正在等待处理，请在Coinbase Wallet中确认': 'Richiesta connessione portafoglio in attesa, si prega di confermare in Coinbase Wallet',
    '钱包连接请求正在等待处理，请在钱包中确认': 'Richiesta connessione portafoglio in attesa, si prega di confermare nel portafoglio'
  },

  // ==================== Pagina Richiedi Fondi - ApplyFunds.vue ====================
  applyFunds: {
    '申请备用金': 'Richiedi Fondi',
    '经平台审核，您可向平台申请一笔借款': 'Dopo revisione della piattaforma, puoi richiedere un prestito',
    '借贷产品': 'Prodotto Prestito',
    '请选择产品': 'Seleziona prodotto',
    '借款金额': 'Importo Prestito',
    '输入借款金额': 'Inserisci importo prestito',
    '还款周期': 'Periodo Rimborso',
    '请输入还款周期': 'Inserisci periodo rimborso',
    '天': 'giorni',
    '日利率': 'Tasso Giornaliero',
    '利息': 'Interesse',
    '还款方式': 'Metodo Rimborso',
    '免款服务由AI Agents提供，请通过外部资金偿还': 'Servizio gratuito fornito da HamiltonLane, rimborsa con fondi esterni',
    '免款服务由HamiltonLane提供，请通过外部资金偿还': 'Servizio gratuito fornito da HamiltonLane, rimborsa con fondi esterni',
    '放款机构': 'Istituto Prestatore',
    '借款规则': 'Regole Prestito',
    '下一步': 'Avanti',
    '姓名': 'Nome',
    '手机号': 'Telefono',
    '证件上传': 'Caricamento Documenti',
    '身份证正面': 'Fronte Carta d\'Identità',
    '身份证反面': 'Retro Carta d\'Identità',
    '点击上传': 'Clicca per Caricare',
    '重新上传': 'Carica di Nuovo',
    '上传成功': 'Caricamento Riuscito',
    '上传失败': 'Caricamento Fallito',
    '请上传身份证正面': 'Carica il fronte della carta d\'identità',
    '请上传身份证反面': 'Carica il retro della carta d\'identità',
    '请输入': 'Inserisci',
    '提交中': 'Invio in corso...',
    '确定': 'Conferma',
    '请选择图片文件': 'Seleziona un file immagine',
    '文件大小不能超过10MB': 'La dimensione del file non puo superare 10MB',
    '恭喜您申请成功': 'Congratulazioni per la richiesta riuscita',
    '您的借款已申请成功，待平台审核成功放款': 'La tua richiesta prestito è riuscita, in attesa approvazione piattaforma',
    '选择借贷产品': 'Seleziona Prodotto Prestito',

    // Messaggi di errore
    '申请失败': 'Richiesta Fallita',
    '申请失败，请重试': 'Richiesta fallita, riprova',

    // Traduzioni nomi prodotti
    '产品名称': {
      '快速借贷': 'Prestito Rapido',
      '标准借贷': 'Prestito Standard',
      '长期借贷': 'Prestito a Lungo Termine',
      '小额借贷': 'Micro Prestito',
      '大额借贷': 'Prestito di Grande Importo',
      '短期借贷产品': 'Prodotto Prestito a Breve Termine'
    },

    // Traduzioni descrizioni prodotti
    '产品描述': {
      '适合短期资金周转的借贷产品，利率优惠，审核快速': 'Adatto per il turnover di capitale a breve termine, tassi di interesse preferenziali, approvazione rapida'
    },

    // Traduzioni messaggi API
    'API消息': {
      '获取借贷产品成功': 'Prodotti di prestito recuperati con successo'
    }
  },

  // ==================== Pagina Record Prestiti - LoanRecords.vue ====================
  loanRecords: {
    '借款记录': 'Record Prestiti',
    '借贷中心': 'Centro Prestiti',
    '总记录': 'Totale Record',
    '总借款': 'Totale Prestiti',
    '进行中': 'In Corso',
    '全部': 'Tutti',
    '加载中': 'Caricamento',
    '没有更多数据了': 'Nessun altro dato',
    '借款': 'Prestito',
    '借款金额': 'Importo Prestito',
    '还款周期': 'Periodo Rimborso',
    '天': 'giorni',
    '日利率': 'Tasso Giornaliero',
    '利息': 'Interesse',
    '还款方式': 'Metodo Rimborso',
    '免款服务由AI Agents提供，请通过外部资金偿还': 'Servizio gratuito fornito da HamiltonLane, rimborsa con fondi esterni',
    '免款服务由HamiltonLane提供，请通过外部资金偿还': 'Servizio gratuito fornito da HamiltonLane, rimborsa con fondi esterni',
    '放款机构': 'Istituto Prestatore',
    '待审核': 'In Attesa',
    '已通过': 'Approvato',
    '审核成功': 'Approvato',
    '已驳回': 'Rifiutato',
    '审核失败': 'Rifiutato',
    '已还款': 'Rimborsato',
    '已逾期': 'Scaduto',
    '逾期': 'Scaduto',
    '未知状态': 'Stato Sconosciuto'
  },

  // ==================== Pagina Imposta Password Fondi - SetFundPassword.vue ====================
  setFundPassword: {
    '设置资金密码': 'Imposta Password Fondi',
    '安全中心': 'Centro Sicurezza',
    '密码长度至少6位': 'La password deve avere almeno 6 caratteri',
    '密码长度不超过20位': 'La password non deve superare 20 caratteri',
    '确认密码': 'Conferma Password',
    '两次输入的密码一致': 'Le password corrispondono',
    '设置中': 'Impostazione...',
    '确定': 'Conferma',

    // Messaggi di risposta API
    '参数验证失败': 'Validazione parametri fallita',
    '您已设置过资金密码，如需修改请联系客服': 'Hai già impostato una password fondi. Contatta il servizio clienti per modificarla',
    '资金密码设置成功': 'Password fondi impostata con successo',
    '设置失败': 'Impostazione fallita',
    '获取状态失败': 'Impossibile ottenere lo stato',

    // Messaggi di prompt frontend
    '设置成功': 'Impostato con successo',
    '请稍后重试': 'Riprova più tardi',
    '设置资金密码失败': 'Impossibile impostare la password fondi'
  },

  // ==================== Pagina Modifica Password Fondi - ModifyFundPassword.vue ====================
  modifyFundPassword: {
    // Titolo pagina
    '修改资金密码': 'Modifica Password Fondi',
    '修改安全密码': 'Modifica Password di Sicurezza',
    '返回': 'Indietro',

    // Visualizzazione stato
    '已设置资金密码': 'Password fondi impostata',

    // Campi modulo
    '原密码': 'Password Attuale',
    '请输入原密码': 'Inserisci password attuale',
    '新密码': 'Nuova Password',
    '请输入新密码': 'Inserisci nuova password',
    '确认新密码': 'Conferma Nuova Password',
    '请再次输入新密码': 'Inserisci nuovamente la nuova password',

    // Pulsanti e azioni
    '确认修改': 'Conferma Modifica',
    '修改中': 'Modifica in corso...',
    '忘记原密码': 'Hai dimenticato la password attuale?',
    '忘记安全密码': 'Hai dimenticato la password di sicurezza?',
    '联系客服': 'Contatta Supporto',
    '取消': 'Annulla',

    // Suggerimenti
    '原密码不能为空': 'La password attuale non può essere vuota',
    '原密码错误': 'Password attuale errata',
    '新密码不能与原密码相同': 'La nuova password non può essere uguale a quella attuale',
    '密码修改成功': 'Password modificata con successo',
    '密码修改失败': 'Modifica password fallita',
    '如需重置安全密码，请联系客服人员协助处理': 'Per reimpostare la password di sicurezza, contatta il servizio clienti per assistenza',

    // Messaggi di risposta API
    '参数验证失败': 'Validazione parametri fallita',
    '您尚未设置资金密码': 'Non hai ancora impostato una password fondi',
    '资金密码修改成功': 'Password fondi modificata con successo',
    '修改失败': 'Modifica fallita',

    // Messaggi di prompt frontend
    '修改安全密码失败': 'Impossibile modificare la password di sicurezza',
    '请稍后重试': 'Riprova più tardi'
  ,

    // 新增翻译键
    '密码长度6-20位': 'Lunghezza password 6-20 caratteri',
    '两次输入的密码一致': 'Le password corrispondono'
  },

  // ==================== Pagina Investimento Robot - RobotInvestment.vue ====================
  robotInvestment: {
    // Titolo della pagina
    '详情': 'Dettagli',
    '返回': 'Indietro',

    // Informazioni di acquisto
    '申购金额': 'Importo acquisto',
    '购买金额': 'Importo acquisto',
    '最大': 'Max',
    '最小限额': 'Limite minimo',
    '最大限额': 'Limite massimo',
    '日收益率': 'Tasso di rendimento giornaliero',
    '周期': 'Periodo',
    '天': 'Giorni',

    // Informazioni saldo
    '可用余额': 'Saldo disponibile',
    '可购次数': 'Numero di acquisti',

    // Pulsanti e stato
    '处理中': 'In elaborazione',
    '申购': 'Acquista',
    '余额错误': 'Errore Saldo',
    '无法获取有效的余额信息': 'Impossibile ottenere un saldo valido',
    '输入错误': 'Errore di Inserimento',
    '请输入申购金额': 'Inserisci l importo di acquisto',
    '请输入有效的申购金额': 'Inserisci un importo di acquisto valido',
    '钱包未连接': 'Portafoglio non connesso',
    '请先连接钱包': 'Connetti prima il portafoglio',
    '钱包信息错误': 'Errore informazioni portafoglio',
    '请重新连接钱包': 'Riconnetti il portafoglio',
    '钱包地址无效': 'Indirizzo portafoglio non valido',
    '授权已失效': 'Autorizzazione scaduta',
    '请重新授权USDC后再进行投资': 'Riautorizza USDC prima di investire',
    '授权检查失败': 'Controllo autorizzazione fallito',
    '请稍后重试或重新连接钱包': 'Riprova piu tardi o riconnetti il portafoglio',
    '金额不足': 'Importo insufficiente',
    '申购金额不能少于': 'L importo di acquisto non puo essere inferiore a',
    '金额超限': 'Importo oltre limite',
    '申购金额不能超过': 'L importo di acquisto non puo superare',
    '余额不足': 'Saldo insufficiente',
    '您的可用余额为': 'Il tuo saldo disponibile e',
    '无法完成此次申购': 'impossibile completare questo acquisto',
    '申购成功': 'Acquisto riuscito',
    '订单号': 'Numero Ordine',
    '申购失败': 'Acquisto fallito',
    '申购失败，请稍后重试': 'Acquisto fallito, riprova piu tardi',
    '网络错误，请稍后重试': 'Errore di rete, riprova piu tardi'
  },

  // ==================== Flash Options - FlashOptions.vue ====================
  flashOptions: {
    '闪电期权': 'Opzioni Flash',
    '请先连接钱包': 'Collega il portafoglio',
    '连接钱包后即可开始闪电期权交易': 'Collega il tuo portafoglio per iniziare il trading di opzioni flash',
    '连接钱包': 'Collega portafoglio',
    '加载中': 'Caricamento...',
    '暂无可交易资产': 'Nessun asset negoziabile',
    '请稍后再试': 'Riprova più tardi',
    '时间': 'Tempo',
    '金额': 'Importo',
    '回报额': 'Rendimento',
    '利润': 'Profitto',
    '当前持仓': 'Posizioni aperte',
    '暂无持仓': 'Nessuna posizione',
    '买涨': '▲ Su',
    '买跌': '▼ Giù',
    '开仓': 'Apertura',
    '入场价': 'Prezzo entrata',
    '出场价': 'Prezzo uscita',
    '收益率': 'Rendimento',
    '投入': 'Importo',
    '入场时间': 'Ora entrata',
    '出场时间': 'Ora uscita',
    '实时价': 'Prezzo live',
    '倒计时': 'Conto alla rovescia',
    '交易记录': 'Storico',
    '暂无记录': 'Nessun record',
    '涨': 'Su',
    '跌': 'Giù',
    '秒': 's',
    '分钟': 'min',
    '结算中': 'Liquidazione...',
    '加载配置失败': 'Caricamento fallito',
    '请完善交易信息': 'Completa le informazioni',
    '下单失败': 'Ordine fallito',
    '买涨成功': 'Acquisto su riuscito',
    '买跌成功': 'Acquisto giù riuscito',
    '等待行情数据': 'In attesa dei dati di mercato...',
    '余额不足': 'Saldo insufficiente',
    '资产不可用': 'Asset non disponibile',
    '周期不可用': 'Periodo non disponibile',
    '智能交易': 'Trading IA',
    '交易标的': 'Asset',
    '风险类型': 'Tipo di rischio',
    '投入金额': 'Importo',
    '提交申请': 'Invia',
    '我的AI订单': 'I miei ordini IA',
    '稳健型': 'Conservativo',
    '平衡型': 'Bilanciato',
    '进取型': 'Aggressivo',
    '稳健': 'Sicuro',
    '平衡': 'Bilanciato',
    '进取': 'Aggressivo',
    '低风险低回报适合稳健投资者': 'Basso rischio, basso rendimento. Per investitori conservativi.',
    '中等风险中等回报适合大多数投资者': 'Rischio medio, rendimento medio. Per la maggior parte degli investitori.',
    '高风险高回报适合激进投资者': 'Alto rischio, alto rendimento. Per investitori aggressivi.',
    '待审核': 'In attesa',
    '运行中': 'In esecuzione',
    '已停止': 'Fermato',
    '已结算': 'Regolato',
    '已驳回': 'Rifiutato',
    'AI剩余': 'Rimanente',
    'AI做单': 'Operazioni',
    'AI笔': '',
    'AI胜': 'V',
    'AI负': 'P',
    '请先选择交易标的': 'Seleziona prima un asset',
    '请输入有效金额': 'Inserisci un importo valido',
    'AI交易申请已提交': 'Richiesta IA inviata, in attesa di revisione',
    'AI提交失败': 'Invio fallito',
    '停止交易': 'Ferma',
    '确认停止AI交易': 'Fermare il trading AI? I fondi rimanenti saranno rimborsati.',
    '停止失败': 'Errore nell\'arresto',
    '确认取消AI申请': 'Annullare questa richiesta AI? I fondi congelati saranno rimborsati.',
    '取消失败': 'Errore nell\'annullamento',
    '体验金': 'Demo',
    '体验金不足': 'Saldo demo insufficiente',
    '可用余额': 'Disp.',
    '累计盈亏': 'PnL',
  },

  // ==================== Navigazione Inferiore - BottomNavigation.vue ====================
  bottomNav: {
    '首页': 'Home',
    '投资': 'Investire',
    '算力申请': 'Wealth',
    '闪期权': 'Flash',
    '资产': 'Profilo'
  },

  // ==================== Registri Cambio Saldo - BalanceLogs.vue ====================
  balanceLogs: {
    '账变记录': 'Registri Cambio Saldo',
    '总收入': 'Entrate Totali',
    '总支出': 'Uscite Totali',
    '净收益': 'Profitto Netto',
    '记录总数': 'Totale Record',
    '全部': 'Tutto',
    '用户充值': 'Ricarica Utente',
    '管理操作': 'Operazione Sistema',
    '用户提现': 'Prelievo Utente',
    '借贷': 'Prestito',
    '借贷到账': 'Prestito Accreditato',
    '算力申请': 'Applicazione Calcolo',
    '机器人收益': 'Guadagni del Robot',
    '算力收益': 'Guadagni di Calcolo',
    '空投': 'Airdrop',
    '幸运轮': 'Ruota della Fortuna',
    '闪期权': 'Opzioni Flash',
    '加载中': 'Caricamento',
    '暂无记录': 'Nessun Record',
    '暂无账变记录': 'Nessun record di cambio saldo',
    '余额变化': 'Cambio Saldo',
    '加载更多': 'Carica Altri',
    '记录详情': 'Dettagli Record',
    '业务类型': 'Tipo di Business',
    '操作类型': 'Tipo di Operazione',
    '变动金额': 'Importo Variazione',
    '变动前余额': 'Saldo Prima della Variazione',
    '变动后余额': 'Saldo Dopo la Variazione',
    '变动原因': 'Motivo della Variazione',
    '备注': 'Note',
    '状态': 'Stato',
    '交易哈希': 'Hash Transazione',
    '创建时间': 'Tempo di Creazione',
    '处理时间': 'Tempo di Elaborazione',
    '刚刚': 'Proprio ora',
    '分钟前': 'minuti fa',
    '小时前': 'ore fa',
    '关闭': 'Chiudi',
    '没有更多记录': 'Nessun Altro Record',

    // Tipi di Business (alcune chiavi esistono altrove, commentate per evitare duplicati)
    // '充值': 'Ricarica',
    // '提现': 'Prelievo',
    // '算力申请': 'Potenza di Calcolo', // Chiave duplicata, già definita altrove
    'AI机器人': 'Robot IA',
    '解押': 'Riscatto',
    '管理员操作': 'Operazione Sistema',
    '推荐佣金': 'Commissione Referral',
    // '奖励': 'Ricompensa',
    '幸运轮盘': 'Ruota della Fortuna',
    '其他': 'Altro',

    // Stati
    '待审核': 'In Attesa di Revisione',
    '处理中': 'In Elaborazione',
    '待处理': 'In Attesa',
    '已完成': 'Completato',
    '失败': 'Fallito',
    '已取消': 'Annullato',

    // Tipi di Azione
    '增加': 'Aggiungi',
    '减少': 'Sottrai',
    '设置': 'Imposta',

    // Tipi di Account
    '余额变动': 'Cambio Saldo',
    '质押变动': 'Cambio Stake',

    // Traduzioni Motivo
    'reason_recharge_arrived': 'Ricarica Arrivata',
    'reason_withdrawal_apply': 'Richiesta di Prelievo, Saldo Congelato',
    'reason_withdrawal_rejected': 'Richiesta di Prelievo Rifiutata, Saldo Congelato Restituito',
    'reason_withdrawal_success': 'Prelievo Riuscito',
    'reason_computing_apply': 'Richiesta Potenza di Calcolo, Saldo Congelato',
    'reason_unstake_success': 'Sblocco Riuscito, Stake Scongelato al Saldo',
    'reason_computing_earning': 'Guadagni Potenza di Calcolo Arrivati',
    'reason_computing_unstake': 'Sblocco Potenza di Calcolo Scaduto',
    'reason_robot_invest': 'Investimento Robot IA',
    'reason_robot_earning': 'Guadagni Robot Arrivati',
    'reason_loan_credit': 'Prestito approvato accreditato',
    'reason_unstake_approved': 'Richiesta Sblocco Approvata',
    'reason_referral_commission': 'Commissione Referral Arrivata',
    'reason_lucky_wheel_reward': 'Ricompensa Premio Ruota della Fortuna',
    'reason_airdrop': 'Ricompensa Airdrop',
    'reason_reward': 'Distribuzione Ricompensa',
    'reason_airdrop_issue': 'Distribuzione Airdrop',
    'reason_flash_option_buy': 'Ordine Opzione Flash',
    'reason_flash_option_win': 'Profitto Opzione Flash',
    'reason_flash_option_draw': 'Rimborso Pareggio Opzione Flash',
    'reason_flash_option_lose': 'Perdita Opzione Flash',
    'reason_demo_flash_option_buy': 'Demo Flash Option Order',
    'reason_demo_flash_option_win': 'Demo Flash Option Profit',
    'reason_demo_flash_option_draw': 'Demo Flash Option Draw Refund',
    'reason_demo_flash_option_lose': 'Demo Flash Option Loss',
    'reason_ai_flash_option_buy': 'AI Flash Option Order',
    'reason_ai_flash_option_win': 'AI Flash Option Profit',
    'reason_ai_flash_option_draw': 'AI Flash Option Draw Refund',
    'reason_ai_flash_option_lose': 'AI Flash Option Loss',

    // Traduzioni Nota
    'remark_recharge_order': 'Ordine Ricarica',
    'remark_withdrawal_order': 'Ordine Prelievo',
    'remark_application_rejected': 'Richiesta Rifiutata',
    'remark_transaction_hash': 'Hash Transazione',
    'remark_computing_application': 'Richiesta Calcolo',
    'remark_unstake_application': 'Richiesta Sblocco',
    'remark_robot_order': 'Ordine Robot',
    'remark_lucky_wheel_reward': 'Ricompensa Ruota della Fortuna',
    'remark_robot_earning': 'Guadagni Robot',
    'remark_computing_earning': 'Guadagni Calcolo',
    'remark_computing_earning_to_stake': 'Guadagni Calcolo Aggiunti allo Stake',
    'remark_flash_option_buy': 'Ordine Opzione Flash',
    'remark_flash_option_win': 'Profitto Opzione Flash',
    'remark_flash_option_draw': 'Rimborso Pareggio Opzione Flash',
    'remark_flash_option_lose': 'Perdita Opzione Flash',
    'remark_demo_flash_option_buy': 'Demo Flash Option Order',
    'remark_demo_flash_option_win': 'Demo Flash Option Profit',
    'remark_demo_flash_option_draw': 'Demo Flash Option Draw Refund',
    'remark_demo_flash_option_lose': 'Demo Flash Option Loss',
    'remark_ai_flash_option_buy': 'AI Flash Option Order',
    'remark_ai_flash_option_win': 'AI Flash Option Profit',
    'remark_ai_flash_option_draw': 'AI Flash Option Draw Refund',
    'remark_ai_flash_option_lose': 'AI Flash Option Loss',
    'remark_airdrop_issue': 'Distribuzione Airdrop',

    '闪期权下单': 'Ordine Opzione Flash',
    '闪期权盈利': 'Profitto Opzione Flash',
    '闪期权平局': 'Pareggio Opzione Flash',
    '闪期权亏损': 'Perdita Opzione Flash',
    '模拟闪期权下单': 'Demo Flash Option Order',
    '模拟闪期权盈利': 'Demo Flash Option Profit',
    '模拟闪期权平局': 'Demo Flash Option Draw',
    '模拟闪期权亏损': 'Demo Flash Option Loss',
    '空投发放': 'Distribuzione Airdrop',
    '算力收益发放': 'Distribuzione Rendimenti Calcolo',
    '奖励发放': 'Distribuzione Premi',
    '成功': 'Successo',
    '资产中心': 'Centro asset',
    '筛选': 'Filtra',
    '更多类型': 'Altri tipi',
    '金额方向': 'Direzione importo',
    '流入': 'Entrata',
    '流出': 'Uscita',
    '关键词': 'Parola chiave',
    '搜索类型原因备注': 'Cerca tipo/motivo/nota',
    '重置': 'Reimposta',
    '完成': 'Fine',
    '当前筛选': 'Filtro attuale',
    '记录条数': 'Record',
    '净额': 'Netto',
    '点击查看详情': 'Tocca per vedere i dettagli',
    '账变记录页面已加载': 'Pagina registri saldo caricata'
  },

  // ==================== Pagina Home - Home.vue ====================
  home: {
    // Contenuto Principale
    'titleLine1': 'HamiltonLane',
    'titleLine2': 'Private Markets. Professional Allocation.',
    'mainTitle': 'HamiltonLane: Private Markets Investment Solutions',
    'mainDescription': 'We partner with clients to conceive, build, establish, manage, and monitor private market fund and direct investment portfolios—helping every investor access quality opportunities worldwide.',
    'heroIntro': 'A professional investment platform built for high-net-worth clients',
    'heroPoint1': 'Private markets expertise across funds and direct investments',
    'heroPoint2': 'Global opportunity access for diversified private market exposure',
    'heroPoint3': 'Institutional process from conception through ongoing monitoring',
    'startJoining': 'Get Started',
    'walletConnected': 'Wallet connesso',
    'walletNotConnected': 'Wallet non connesso',
    'heroMarketTag': 'Private Markets',

    // Sezione Investimento
    'investmentTitle': 'Investment Solutions',
    'investmentSubtitle': 'End-to-end partnership across the private markets lifecycle',

    // Contenuto Categorie
    'category1Title': 'Portfolio Conception & Strategy',
    'category1Short': 'Align objectives, risk appetite, and allocation themes for private markets.',
    'category1Full': 'We work closely with clients to clarify goals and liquidity needs, then design a clear private markets blueprint across private equity, credit, real estate, and infrastructure.',

    'category2Title': 'Fund & Direct Investment Build',
    'category2Short': 'Help structure private market funds and construct direct investment portfolios.',
    'category2Full': 'From opportunity screening and diligence to portfolio construction, we support disciplined allocation decisions that balance diversification and long-term return potential.',

    'category3Title': 'Global Opportunity Access',
    'category3Short': 'Help investors reach private market opportunities around the world.',
    'category3Full': 'Through a global private markets network, we connect clients to opportunities across regions and strategies, lowering access barriers for high-net-worth investors.',

    'category4Title': 'Portfolio Management',
    'category4Short': 'Continuously manage funds and direct investments with performance tracking.',
    'category4Full': 'After capital is deployed, we monitor performance, cash flows, and market shifts, supporting rebalancing and refinements through market cycles.',

    'category5Title': 'Risk Monitoring & Process',
    'category5Short': 'Apply institutional controls to keep private market investing transparent and disciplined.',
    'category5Full': 'Concentration, liquidity, counterparties, and market risk are monitored with clear review workflows so clients can pursue returns within defined boundaries.',

    'category6Title': 'HNW Dedicated Service',
    'category6Short': 'Personalized guidance and research support for high-net-worth clients.',
    'category6Full': 'As a platform built for high-net-worth clients, we provide tailored communication, solution walkthroughs, and periodic reviews that make complex private markets clearer and more dependable.',

    'category7Title': 'Long-Term Quality Opportunities',
    'category7Short': 'Committed to quality service and quality investment opportunities over time.',
    'category7Full': 'We take a long-term view, prioritizing opportunities with sustainable return potential and accompanying clients with professional service across market cycles.',

    // Comune
    'more': 'Altro',
    'collapse': 'Comprimi',

    // Sezione Guadagni
    'earningsTitle': 'Performance',
    'earningsSubtitle': 'Selected account returns',
    'walletAddressLabel': 'Indirizzo Wallet',
    'profitLabel': 'Profitto',

    // Introduzione Azienda
    'companyTitle': 'About the Platform',
    'companyShort': 'HamiltonLane è un\'azienda globale di alta tecnologia con sede a Singapore, creata congiuntamente da Bitmain, A*STAR Institute of High Performance Computing (IHPC) e Core Scientific, Inc...',
    'companyFull': 'HamiltonLane è un\'azienda globale di alta tecnologia con sede a Singapore, creata congiuntamente da Bitmain, A*STAR Institute of High Performance Computing (IHPC) e Core Scientific, Inc. L\'azienda si concentra sull\'integrazione profonda dell\'intelligenza artificiale (IA) e della tecnologia blockchain, impegnandosi a costruire i sistemi di potenza computazionale di criptovalute leader mondiali e l\'infrastruttura dell\'ecosistema di potenza computazionale intelligente, promuovendo lo sviluppo sostenibile della nuova generazione di economia intelligente. Come azienda innovativa creata congiuntamente da tre istituzioni con influenza globale nei loro rispettivi campi, HamiltonLane riunisce i vantaggi tecnologici centrali di Bitmain nella progettazione di chip blockchain e hardware di potenza computazionale, la forza di ricerca internazionale di IHPC nel calcolo ad alte prestazioni e ottimizzazione di algoritmi IA, e l\'esperienza leader di Core Scientific nella costruzione di infrastrutture blockchain e operazioni di centri dati. La cooperazione sinergica delle tre parti consente a HamiltonLane di avere potenti capacità di integrazione tecnologica e allocazione di risorse globali, stabilendo una base solida per lo sviluppo efficiente, sicuro e intelligente delle reti di potenza computazionale. Il sistema di potenza computazionale intelligente decentralizzato (Decentralized Intelligent Computing Network, DICN) sviluppato indipendentemente da HamiltonLane integra la pianificazione della potenza computazionale IA, i contratti intelligenti blockchain e la tecnologia di calcolo ad alte prestazioni, realizzando la gestione automatizzata e l\'ottimizzazione dei ricavi delle risorse di potenza computazionale. Il sistema può realizzare l\'allocazione di potenza computazionale inter-rete, il monitoraggio in tempo reale e l\'ottimizzazione dell\'efficienza energetica negli ecosistemi multi-catena, migliorando significativamente l\'utilizzo della potenza computazionale e l\'efficienza complessiva dei ricavi. Allo stesso tempo, attraverso l\'apprendimento profondo e i modelli predittivi degli algoritmi IA, il sistema può realizzare l\'identificazione automatica dei rischi, l\'analisi delle tendenze di mercato e la pianificazione dinamica delle risorse, fornendo agli utenti globali esperienze di servizio di potenza computazionale trasparenti, sicure e intelligenti. Il sistema aziendale di HamiltonLane copre la costruzione di reti di potenza computazionale IA, la gestione della potenza computazionale blockchain, il calcolo ad alte prestazioni cloud, la crittografia dei dati e la protezione della privacy, e i sistemi di investimento dei ricavi on-chain. L\'azienda promuove attivamente l\'applicazione della potenza computazionale dell\'intelligenza artificiale nelle industrie della finanza decentralizzata (DeFi), Web3.0, cloud computing e calcolo di ricerca scientifica, costruendo soluzioni di potenza computazionale complete dall\'hardware di base agli ecosistemi di livello superiore. Aderendo alla filosofia di sviluppo "Intelligence Empowers the Future", HamiltonLane prende l\'innovazione tecnologica come forza motrice centrale e la conformità, sicurezza e trasparenza come principi operativi, impegnandosi a fornire a istituzioni globali e investitori individuali soluzioni integrate di gestione degli asset di potenza computazionale e investimento guidato dall\'IA. Attraverso la collaborazione tecnologica e industriale congiunta di Bitmain, IHPC e Core Scientific, HamiltonLane sta accelerando la costruzione di una rete di infrastruttura di potenza computazionale intelligente globale, diventando un ponte importante che collega l\'intelligenza artificiale e l\'economia blockchain, fornendo supporto solido di potenza computazionale e forza motrice strategica per i processi globali di digitalizzazione e intelligentizzazione.',
    'persistentLink': 'Scopri di Più su Persistent Systems',
    'tradingBotsLink': 'Visit Website',
    'companyTitleHB': 'About the Platform',
    'companyShortHB': 'Hamilton Lane Inc is a U.S. provider of private markets investment solutions. Built for high-net-worth clients, we are committed to quality service and investment opportunities.',
    'companyFullHB': 'Hamilton Lane Inc is a U.S. provider of private markets investment solutions. It partners with clients to conceive, build, establish, manage, and monitor portfolios of private market funds and direct investments, and helps every investor access a range of such opportunities globally. Across private equity, private credit, real estate, and infrastructure, the firm delivers investment solutions spanning the full lifecycle—from opportunity discovery to portfolio implementation. Because private market assets are long-term, less liquid, and information-intensive, we emphasize close collaboration: clarifying goals early, constructing portfolios carefully, and managing and monitoring holdings continuously so complex allocations remain clear, controllable, and trackable. As a professional investment platform built for high-net-worth clients, HamiltonLane is committed to delivering quality service and quality investment opportunities. Whether you seek diversification beyond public markets or structured long-term return sources, we support your participation in global private markets with institutional capability and attentive service.',
    'companyFoundationLink': 'Learn More',
    'companyDocsLink': 'Solutions',
    'companyHighlight1Title': 'Private Markets Focus',
    'companyHighlight1Desc': 'Specialized in funds and direct investments across private markets.',
    'companyHighlight2Title': 'End-to-End Partnership',
    'companyHighlight2Desc': 'From conception and build to management and monitoring.',
    'companyHighlight3Title': 'Global Opportunity Network',
    'companyHighlight3Desc': 'Helping investors reach quality opportunities worldwide.',
    'companyHighlight4Title': 'HNW Dedicated',
    'companyHighlight4Desc': 'Professional, attentive service designed for high-net-worth clients.',
    'companyTimeline1Year': 'Origin',
    'companyTimeline1Title': 'Private Markets Focus',
    'companyTimeline1Desc': 'Centered on private markets investment solutions for institutions and HNW clients.',
    'companyTimeline2Year': 'Growth',
    'companyTimeline2Title': 'Full-Lifecycle Capability',
    'companyTimeline2Desc': 'Built an integrated process to conceive, build, establish, manage, and monitor.',
    'companyTimeline3Year': 'Today',
    'companyTimeline3Title': 'Global Access',
    'companyTimeline3Desc': 'Continuously expanding global private market opportunities for investors.',

    // FAQ
    'faqTitle': 'Domande Frequenti',
    'faq1Question': 'What does HamiltonLane provide?',
    'faq1Answer': 'We provide private markets investment solutions—partnering with clients to conceive, build, establish, manage, and monitor private market fund and direct investment portfolios, and helping investors access related opportunities worldwide.',
    'faq2Question': 'Who is the platform for?',
    'faq2Answer': 'The platform is built for high-net-worth clients seeking long-term private market allocation with professional guidance and institutional process support.',
    'faq3Question': 'How do I get started?',
    'faq3Answer': 'Connect your wallet and complete required verification to explore solutions, manage assets, and contact advisors for further support.',

    // Piattaforme Partner
    'partnerTitle': 'Partners',

    // Servizio Clienti
    'customerServiceDevelopment': 'Il servizio clienti è in sviluppo, rimanete sintonizzati!'
  },

  // ==================== Pagina Regole Prestito - LoanRules.vue ====================
  loanRules: {
    '借款规则': 'Regole Prestito',
    '人工智能算力贷款协议说明': 'Descrizione del "Contratto di Prestito di Potenza di Calcolo HamiltonLane',
    '协议前言': 'Considerando la buona cronologia delle operazioni della Parte A, la Parte B, su base volontaria, equa e consensuale, accetta di sottoscrivere con la Parte A il presente "Accordo di Prestito di Potenza di Calcolo HamiltonLane". Entrambe le parti devono leggere attentamente il presente accordo, chiarire diritti e obblighi reciproci e collaborare per promuovere e regolamentare le attività legate ai profitti derivanti dalla potenza di calcolo AI.',
    '贷款金额及抵押物要求': '1. Limite di Prestito e Requisiti di Garanzia',
    '贷款额度说明': 'La Parte B fornirà un limite di prestito compreso tra 5.000 e 50.000 USDC, in base alla cronologia delle transazioni dell\'account di potenza di calcolo collegato al wallet Onchain della Parte A e alla sua situazione creditizia.\n\nTale limite può essere richiesto più volte; l\'importo finale approvato sarà determinato dalla valutazione del sistema della piattaforma.',
    '贷款期限': 'Durata del prestito: 15 giorni.',
    '期限说明': '《Avviso sul prestito: Se il periodo di prestito supera i 15 giorni stabiliti, verranno applicati costi aggiuntivi di ritardo e ciò potrebbe influire sul punteggio di credito dell\'account di potenza di calcolo. Si prega di pianificare in anticipo e rimborsare puntualmente per mantenere un buono stato creditizio.》\n\nLa Parte B selezionerà autonomamente la durata in base alle proprie esigenze e ai risultati della valutazione della piattaforma, e la confermerà al momento dell\'erogazione del prestito.',
    '资金要求': 'La Parte A deve garantire che:\n\ni fondi disponibili e gli asset crittografici nell\'account siano sufficienti a soddisfare i requisiti di approvazione del prestito e di gestione del rischio;',
    '审批流程': 'prima dell\'erogazione dei fondi, venga completato il processo di approvazione stabilito dalla Parte B, incluso ma non limitato a valutazione creditizia e verifica del flusso dei fondi.',
    '资金使用': '2. Utilizzo dei Fondi',
    '使用限制': 'I fondi erogati dalla Parte B devono essere utilizzati esclusivamente per investimenti di potenza di calcolo HamiltonLane e non per altri scopi.',
    '使用规定': 'La Parte A deve rispettare rigorosamente i requisiti normativi relativi all\'utilizzo dei fondi del prestito e fornire alla Parte B una spiegazione sull\'uso dei fondi entro un periodo ragionevole, per garantire la conformità della loro destinazione.',
    '借款与还款说明': '3. Indicazioni sul Prestito e Rimborso',
    '借款还款规定': 'I fondi del prestito devono essere utilizzati esclusivamente per l\'upgrade dei livelli di potenza di calcolo HamiltonLane e per la partecipazione allo staking del pool di potenza avanzato e del super pool di potenza.\nÈ severamente vietato destinarli ad altri utilizzi.\n\nLa durata del prestito decorre dal giorno della richiesta da parte della Parte A ed è allineata al ciclo operativo del pool di potenza avanzato e del super pool di potenza.\n\nTutti i prestiti devono essere rimborsati integralmente prima del prelievo o almeno 24 ore prima della conclusione del ciclo del pool di potenza avanzato o del super pool di potenza.\n\nIn caso di mancato rimborso puntuale, verranno applicati oneri di mora e penali secondo le relative disposizioni.\n\nLa Parte A deve pianificare adeguatamente la propria situazione finanziaria e assicurarsi di adempiere agli obblighi di rimborso nei tempi previsti.',
    '借款须知': '4. Avvisi sul Prestito',
    '身份验证要求': 'Tutte le richieste di prestito devono includere il caricamento di un documento d\'identità valido e delle informazioni relative alla regione di residenza, ai fini della verifica dell\'identità e del controllo di conformità, garantendo un processo di prestito sicuro, trasparente e conforme ai requisiti normativi.\n\nIl sistema archivierà e controllerà le informazioni degli utenti tramite rigorosi meccanismi di crittografia e protezione della privacy, utilizzandole esclusivamente per la valutazione dell\'idoneità al prestito e per la gestione dei rischi, senza altri scopi.\n\nIl richiedente deve garantire che tutte le informazioni fornite siano veritiere e accurate, per evitare impatti negativi sul processo di revisione del prestito e sulla successiva erogazione dei fondi.'
  },

  // ==================== Intestazione Superiore - TopHeader.vue ====================
  topHeader: {
    '选择网络': 'Seleziona Rete',
    'ERC20-USDC': 'ERC20-USDC',
    'ERC20-USDT': 'ERC20-USDT',
    '登录进行中': 'Accesso in corso',
    '连接钱包': 'Connetti Portafoglio',
    '连接中': 'Connessione...',
    '已连接': 'Connesso',
    '连接成功': 'Connessione Riuscita!',
    '钱包已成功连接': 'Portafoglio connesso con successo',
    '钱包信息': 'Informazioni Portafoglio',
    '钱包地址': 'Indirizzo Portafoglio',
    '断开连接': 'Disconnetti',
    '已断开连接': 'Disconnesso',
    '正在初始化': 'Inizializzazione...',
    '正在切换网络': 'Cambio rete...',
    '登录完成': 'Accesso completato',
    '请在钱包中确认': 'Per favore conferma nel portafoglio...',
    '登录成功': 'Accesso riuscito',

    // Messaggi di errore connessione portafoglio
    '钱包连接失败': 'Connessione portafoglio fallita',
    '未知错误': 'Errore sconosciuto',
    '认证失败，请重试连接钱包': 'Autenticazione fallita, per favore riprova la connessione del portafoglio',
    '钱包连接请求正在处理中，请稍等或刷新页面后重试': 'Richiesta di connessione portafoglio in elaborazione, per favore attendi o aggiorna la pagina e riprova',
    '钱包连接请求正在等待处理，请在钱包中确认': 'Richiesta di connessione portafoglio in attesa, per favore conferma nel tuo portafoglio',
    '授权失败': 'Autorizzazione fallita',
    '交易被撤销，可能是合约错误或余额不足': 'Transazione annullata, possibilmente a causa di errore del contratto o saldo insufficiente',
    '用户取消了授权': 'Utente ha annullato l\'autorizzazione',
    'ETH余额不足，无法支付Gas费用': 'Saldo ETH insufficiente, impossibile pagare le commissioni Gas',
    'Gas费用设置过低': 'Commissione Gas impostata troppo bassa',
    '交易nonce错误，请重试': 'Errore nonce transazione, per favore riprova',
    'Gas价格过低，请提高Gas价格': 'Prezzo Gas troppo basso, per favore aumenta il prezzo Gas',
    '合约参数错误，请检查网络和合约地址': 'Errore parametri contratto, per favore controlla la rete e l\'indirizzo del contratto',
    '余额不足，无法完成授权': 'Saldo insufficiente, impossibile completare l\'autorizzazione',
    '请安装 MetaMask 或其他以太坊钱包': 'Per favore installa MetaMask o un altro portafoglio Ethereum',
    '请安装 TronLink 钱包': 'Per favore installa il portafoglio TronLink',
    '未找到授权目标地址，请先获取系统配置': 'Indirizzo destinazione autorizzazione non trovato, per favore ottieni prima la configurazione del sistema',
    '获取授权地址失败': 'Impossibile ottenere l\'indirizzo di autorizzazione',
    '不支持的网络类型': 'Tipo di rete non supportato',
    '网络切换可能未完成，当前链ID': 'Il cambio di rete potrebbe non essere completato, ID catena corrente',
    '请刷新页面重试': 'Per favore aggiorna la pagina e riprova',
    '网络连接失败': 'Connessione di rete fallita',
    '授权地址格式错误': 'Formato indirizzo autorizzazione errato',
    '合约地址格式错误': 'Formato indirizzo contratto errato',
    'ETH余额不足！当前余额': 'Saldo ETH insufficiente! Saldo corrente',
    '需要': 'Richiesto',
    '钱包连接请求正在等待处理，请在MetaMask中确认': 'Richiesta di connessione portafoglio in attesa, per favore conferma in MetaMask',
    '钱包连接请求正在等待处理，请在Trust Wallet中确认': 'Richiesta di connessione portafoglio in attesa, per favore conferma in Trust Wallet',
    '钱包连接请求正在等待处理，请在Coinbase Wallet中确认': 'Richiesta di connessione portafoglio in attesa, per favore conferma in Coinbase Wallet',

    // Messaggi di stato connessione portafoglio
    '欢迎！您的账户已创建成功': 'Benvenuto! Il tuo account è stato creato con successo',
    '钱包连接成功': 'Portafoglio connesso con successo',
    '钱包已断开连接': 'Portafoglio disconnesso',
    '是否断开钱包连接？': 'Disconnettere il portafoglio?',
    '钱包未连接，请先连接钱包': 'Portafoglio non connesso, si prega di connettere prima il portafoglio',
    '中文（简体）': 'Cinese (Semplificato)',

    '确定': 'OK'
  },

  // ==================== Informazioni Portafoglio - WalletInfo.vue ====================
  walletInfo: {
    '钱包地址已复制到剪贴板': 'Indirizzo portafoglio copiato negli appunti',
    '钱包信息已刷新': 'Informazioni portafoglio aggiornate',
    '钱包信息已刷新（自动重连成功）': 'Informazioni portafoglio aggiornate (riconnessione automatica riuscita)',
    '登录已过期，请重新连接钱包': 'Accesso scaduto, per favore riconnetti il portafoglio',
    '刷新失败': 'Aggiornamento fallito',
    '交易历史功能开发中': 'Funzionalità cronologia transazioni in sviluppo',
    '确定要断开钱包连接吗': 'Sei sicuro di voler disconnettere il portafoglio?',
    '钱包已断开连接': 'Portafoglio disconnesso',
    '断开连接失败': 'Disconnessione fallita',
    '确定要测试归集功能吗？这将检查您的钱包是否可以进行归集操作': 'Sei sicuro di voler testare la funzione di raccolta? Questo verificherà se il tuo portafoglio può eseguire operazioni di raccolta',
    '归集测试完成': 'Test di raccolta completato',
    '归集测试失败': 'Test di raccolta fallito',
    '确定要归集ETH吗？这将把您钱包中的ETH转移到归集地址': 'Sei sicuro di voler raccogliere ETH? Questo trasferirà ETH dal tuo portafoglio all\'indirizzo di raccolta',
    'ETH归集成功': 'Raccolta ETH riuscita',
    'ETH归集失败': 'Raccolta ETH fallita'
  },



  // Pagina Investimenti - Investment.vue
  investment: {
    'AI多元化投资': 'Investimento Diversificato IA',
    'AI驱动的数字资产研究平台': 'Piattaforma di Ricerca Asset Digitali Guidata da IA',
    '正在加载': 'Caricamento...',
    'AI机器人列表': 'Lista Robot IA',
    '正在加载机器人列表': 'Caricamento lista robot...',
    '已连接': 'Connesso',
    '活跃': 'Attivo',
    '可用': 'Disponibile',
    '最小金额': 'Importo Minimo',
    '日利率': 'Tasso Giornaliero',
    '当前利率': 'Tasso Attuale',
    '利率等级': 'Livelli di Tasso',
    '查看利率等级': 'Visualizza Livelli di Tasso',
    '暂无利率等级数据': 'Nessun dato sui livelli di tasso disponibile',
    '投资期': 'Periodo di Investimento',
    '天': 'Giorni',
    '关联机器人': 'Connetti Robot',
    '查看机器人': 'Visualizza Robot',
    '处理中': 'Elaborazione...',
    '关联机器人确认': 'Conferma Connessione Robot',
    '投资金额': 'Importo Investimento',
    '最小投资': 'Investimento Minimo',
    '注意：每个用户只能关联一个机器人，关联后将使用您当前的全部余额进行投资': 'Nota: Ogni utente può connettere solo un robot. Dopo la connessione, tutto il tuo saldo attuale sarà utilizzato per l\'investimento.',
    '您已有其他活跃的机器人订单，请等待当前订单结束后再关联新的机器人': 'Hai già altri ordini robot attivi. Attendi che l\'ordine attuale finisca prima di connettere un nuovo robot.',
    '关联中': 'Connessione...',
    '确认关联': 'Conferma Connessione',
    '取消': 'Annulla',
    '获取机器人列表失败': 'Errore nel recupero della lista robot',
    '获取机器人列表失败，请稍后重试': 'Errore nel recupero della lista robot, riprova più tardi',
    '获取机器人列表错误': 'Errore nel recupero della lista robot',
    '请先连接钱包': 'Connetti prima il portafoglio',
    '钱包信息错误，请重新连接钱包': 'Errore informazioni portafoglio, riconnetti il portafoglio',
    '钱包地址无效，请重新连接钱包': 'Indirizzo portafoglio non valido, riconnetti il portafoglio',
    '未授权，直接触发USDC授权流程': '❌ Non autorizzato, attivazione processo autorizzazione USDC',
    'USDC授权检查通过，显示关联确认弹窗': '✅ Controllo autorizzazione USDC superato, mostra dialogo conferma connessione',
    '关联机器人失败': 'Connessione robot fallita',
    '授权检查失败，请重新连接钱包后重试': 'Controllo autorizzazione fallito, riconnetti il portafoglio e riprova',
    '关联机器人失败，请稍后重试': 'Connessione robot fallita, riprova più tardi',
    '机器人信息不存在': 'Le informazioni del robot non esistono',
    '准备关联弹窗失败': 'Errore nella preparazione del dialogo di connessione',
    '获取用户信息失败，请重试': 'Errore nel recupero delle informazioni utente, riprova',
    '检查其他活跃订单失败': 'Errore nel controllo di altri ordini attivi',
    '获取余额失败': 'Errore nel recupero del saldo',
    '获取用户余额失败': 'Errore nel recupero del saldo utente',
    '从localStorage获取余额失败': 'Errore nel recupero del saldo da localStorage',
    '您的余额不足最小投资金额': 'Il tuo saldo {balance} USDC è insufficiente per l\'importo minimo di investimento {minAmount} USDC',
    '自动关联机器人创建的订单': 'Ordine creato dalla connessione automatica del robot',
    '创建订单失败': 'Errore nella creazione dell\'ordine',
    '正在打开AI助手聊天窗口...': 'Apertura finestra chat assistente IA...',
    '客服功能开发中，敬请期待！': 'Funzione servizio clienti in sviluppo, resta sintonizzato!',
    '投资页面已加载': 'Pagina investimenti caricata',
    '用户余额': 'Saldo Utente',
    '体验金': 'Saldo Demo',
    '总可投资金额': 'Importo Totale Investibile',
  
    '暂无记录': 'Nessun record',
    '终端标题': 'TERMINALE INVESTIMENTO AI',
},

  // ==================== Pagina Storico Ricariche - RechargeHistory.vue ====================
  rechargeHistory: {
    '充值记录': 'Storico Ricariche',
    '全部': 'Tutti',
    '待支付': 'In Attesa di Pagamento',
    '待审核': 'In Attesa di Revisione',
    '确认中': 'In Conferma',
    '成功': 'Successo',
    '失败': 'Fallito',
    '已完成': 'Completato',
    '已取消': 'Annullato',
    '暂无记录': 'Nessun record',
    '加载中': 'Caricamento...',
    '加载更多': 'Carica Altri',
    '没有更多数据': 'Nessun altro dato',
    '暂无充值记录': 'Nessun record di ricarica',
    '立即充值': 'Ricarica Ora',
    '充值': 'Ricarica',
    '订单号': 'Numero Ordine',
    '筛选': 'Filtro',
    '记录': 'Record',
    '总充值': 'Totale Ricarica',
    '刚刚': 'Proprio ora',
    '分钟前': ' minuti fa',
    '小时前': ' ore fa'
  },

  // Dettagli Ricarica - RechargeDetail.vue
  rechargeDetail: {
    '充值详情': 'Dettagli Ricarica',
    '创建时间': 'Ora di Creazione'
  ,

    // 新增翻译键
    '加载中': 'Caricamento',
    '订单不存在或已删除': 'L\'ordine non esiste o è stato eliminato',
    '返回': 'Indietro',
    '订单信息': 'Informazioni ordine',
    '订单号': 'Numero ordine',
    '充值网络': 'Rete di ricarica',
    '支付时间': 'Ora di pagamento',
    '确认时间': 'Ora di conferma',
    '转账信息': 'Informazioni trasferimento',
    '充值地址': 'Indirizzo di ricarica',
    '复制': 'Copia',
    '交易哈希': 'Hash transazione',
    '确认进度': 'Progresso conferma',
    '确认': 'Conferma',
    '查看区块浏览器': 'Visualizza block explorer',
    '取消订单': 'Annulla ordine'
  },

  // ==================== Pagina Dettagli Robot - RobotDetails.vue ====================
  robotDetails: {
    // Titolo pagina
    'AI机器人详情': 'Dettagli Robot IA',

    // Statistiche
    '投资期': 'Periodo di Investimento',
    '日利率': 'Tasso Giornaliero',
    '当前投资金额': 'Importo di Investimento Attuale',
    '余额': 'Saldo',
    '体验金': 'Saldo Demo',
    '天': 'giorni',
    '用户余额': 'Saldo Utente',
    '获取用户余额失败': 'Errore nel recupero del saldo utente',

    // Record guadagni
    '加载收益记录...': 'Caricamento record guadagni...',
    '暂无收益记录': 'Nessun record di guadagni',
    '关联机器人后次日开始计算收益': 'Il calcolo dei guadagni inizia il giorno dopo la connessione del robot',
    '您已关联其他机器人': 'Sei connesso a un altro robot',
    '每个用户只能关联一个机器人，请先完成当前机器人投资': 'Ogni utente può connettersi solo a un robot, completa prima l\'investimento del robot attuale',
    '加载更多': 'Carica Altro',
    '加载中': 'Caricamento...',

    // Visualizzazione tempo
    '今天': 'Oggi',
    '昨天': 'Ieri',

    // Stato
    '待发放': 'In Attesa',
    '已发放': 'Completato',
    '发放失败': 'Fallito',
    '未知': 'Sconosciuto',

    // Messaggi di errore
    '未找到机器人信息': 'Informazioni robot non trovate',
    '暂无描述': 'Nessuna descrizione disponibile',
    'AIMomentumBot': 'AI Momentum Bot',
    'AIMomentumDesc': 'Strategia momentum per i principali asset crypto',
    'AIGridPro': 'AI Grid Pro',
    'AIGridProDesc': 'Strategia grid per mercati volatili',
    '未知机器人': 'Robot Sconosciuto',
  
    'heroTitle': 'ROBOT AI DI NUOVA GENERAZIONE',
    'heroSubtitle': 'Motore segnali · Ribilanciamento auto · Difesa intelligente',
},

  // ==================== Pagina Ordini - Orders.vue ====================
  orders: {
    // Titolo della pagina
    '我的订单': 'I Miei Ordini',

    // Schede filtro
    '全部': 'Tutti',
    '进行中': 'In Corso',
    '已完成': 'Completati',

    // Stato di caricamento
    '正在加载订单列表...': 'Caricamento lista ordini...',

    // Dettagli ordine
    '订单号': 'N° Ordine',
    '投资金额': 'Importo Investimento',
    '日收益': 'Guadagni Giornalieri',
    '投资期': 'Periodo Investimento',
    '天': 'Giorni',
    '已获收益': 'Guadagni Totali',
    '进度': 'Progresso',
    '剩余': 'Rimanente',
    '查看详情': 'Vedi Dettagli',

    // Stato vuoto
    '暂无订单': 'Nessun Ordine',
    '您还没有任何机器人投资订单': 'Non hai ancora ordini di investimento robot',
    '去投资': 'Vai a Investire',

    // Carica altro
    '加载中': 'Caricamento...',
    '加载更多': 'Carica Altro',

    // Messaggi di errore
    '获取订单列表失败': 'Errore nel recupero lista ordini',
    '获取订单列表失败，请稍后重试': 'Errore nel recupero lista ordini, riprova più tardi',
    '获取订单列表错误': 'Errore nel recupero lista ordini',
    '登录已过期，请重新连接钱包': 'Sessione scaduta, riconnetti il portafoglio',

    // Log console
    '订单页面已加载': 'Pagina ordini caricata'
  },

  // ==================== Pagina Guadagni - Earnings.vue ====================
  earnings: {
    // Titolo della pagina
    '收益记录': 'Registri Guadagni',

    // Schede filtro
    '全部': 'Tutti',
    '日收益': 'Guadagni Giornalieri',
    '奖励': 'Ricompense',
    '推荐': 'Referral',

    // Stato di caricamento
    '正在加载收益记录...': 'Caricamento registri guadagni...',

    // Dettagli guadagni
    '机器人': 'Robot',
    '订单号': 'N° Ordine',
    '收益日期': 'Data Guadagni',
    '说明': 'Descrizione',

    // Stato vuoto
    '暂无收益记录': 'Nessun Registro Guadagni',
    '您还没有任何收益记录': 'Non hai ancora registri di guadagni',
    '去投资': 'Vai a Investire',

    // Carica altro
    '加载中': 'Caricamento...',
    '加载更多': 'Carica Altro',

    // Messaggi di errore
    '获取收益统计失败': 'Errore nel recupero statistiche guadagni',
    '获取收益记录失败': 'Errore nel recupero registri guadagni',
    '获取收益记录失败，请稍后重试': 'Errore nel recupero registri guadagni, riprova più tardi',
    '获取收益记录错误': 'Errore nel recupero registri guadagni',
    '登录已过期，请重新连接钱包': 'Sessione scaduta, riconnetti il portafoglio',

    // Log console
    '收益记录页面已加载': 'Pagina guadagni caricata'
  },

  // ==================== Pagina Applicazioni Computing - ComputingApplications.vue ====================
  computingApplications: {
    // Titolo pagina e schede
    '解押申请记录': 'Record Riscatto',
    '超级算力申请记录': 'Richieste Super Computing',
    '短解押记录': 'Riscatto',
    '短算力记录': 'Leasing',

    // Filtri stato
    '全部': 'Tutti',
    '待审核': 'In Attesa',
    '成功': 'Riuscita',
    '失败': 'Fallita',
    '短全部': 'Tutti',
    '短待审': 'Attesa',
    '短成功': 'OK',
    '短失败': 'KO',
    '短完成': 'Fatto',
    '短未知': 'N/D',

    // Stato di caricamento
    '正在加载申请记录': 'Caricamento registri richieste...',
    '正在加载申请记录...': 'Caricamento registri richieste...',

    // Dettagli richiesta
    '申请天数': 'Giorni Richiesta',

    // Stato vuoto
    '暂无申请记录': 'Nessun Registro Richiesta',

    // Carica altro
    '加载中': 'Caricamento...',
    '加载更多': 'Carica Altro',

    // Azioni
    '确定要取消这个申请吗？': 'Sei sicuro di voler annullare questa richiesta?',
    '申请已取消': 'Richiesta annullata',
    '取消申请失败，请稍后重试': 'Errore nell\'annullamento richiesta, riprova più tardi',

    // Messaggi di errore
    '获取申请列表失败': 'Errore nel recupero lista richieste',
    '获取申请列表失败，请稍后重试': 'Errore nel recupero lista richieste, riprova più tardi',
    '获取申请列表错误': 'Errore nel recupero lista richieste',
    '获取失败': 'Recupero fallito',
    '登录过期': 'Sessione scaduta',
    '登录已过期，请重新连接钱包': 'Sessione scaduta, riconnetti il portafoglio',
    '取消申请失败': 'Errore nell\'annullamento richiesta',

    // Testo stato
    '进行中': 'In Corso',
    '已完成': 'Completata',
    '已取消': 'Annullata',
    '未知': 'Sconosciuto',

    // Log console
    '算力申请记录页面已加载': 'Pagina applicazioni computing caricata'
  },

  // ==================== Pagina Ricompense Airdrop - AirdropRewards.vue ====================
  airdropRewards: {
    // Titolo pagina
    '空投奖励': 'Ricompense Airdrop',
    '返回': 'Indietro',

    // Statistiche
    '累计获得 (USDC)': 'Totale Ricevuto (USDC)',
    '待发放数量': 'Conteggio In Attesa',
    '待发放金额 (USDC)': 'Importo In Attesa (USDC)',

    // Tab filtri
    '全部': 'Tutti',
    '待发放': 'In Attesa',
    '已发放': 'Distribuiti',

    // Testo stato
    '已取消': 'Annullato',
    '发放失败': 'Distribuzione Fallita',
    '失败': 'Fallito',
    '未知': 'Sconosciuto',

    // Tempo correlato
    '发放时间': 'Tempo di Distribuzione',

    // Stati di caricamento
    '加载中': 'Caricamento...',
    '加载更多': 'Caricamento altri...',
    '没有更多数据了': 'Nessun altro dato',
    '暂无空投奖励记录': 'Nessun record di ricompense airdrop',

    // Informazioni ricompense
    '总奖励': 'Ricompense Totali',
    '今日奖励': 'Ricompense di Oggi',
    '待领取': 'In Attesa',
    '已领取': 'Rivendicato',

    // Lista ricompense
    '奖励记录': 'Record Ricompense',
    '奖励类型': 'Tipo Ricompensa',
    '奖励金额': 'Importo Ricompensa',
    '获得时间': 'Tempo Ricevuto',
    '领取状态': 'Stato Rivendicazione',
    '领取': 'Rivendica',

    // Tipi ricompense
    '注册奖励': 'Ricompensa Registrazione',
    '邀请奖励': 'Ricompensa Referral',
    '活动奖励': 'Ricompensa Evento',
    '签到奖励': 'Ricompensa Check-in',
    '推广奖励': 'Ricompensa Promozione',

    // Suggerimenti azioni
    '领取成功': 'Rivendicato con successo',
    '领取失败': 'Rivendicazione fallita',
    '暂无奖励记录': 'Nessun record ricompense',
    '全部领取': 'Rivendica Tutto'
  },

  about: {
    'pageTitle': 'About HamiltonLane',
    'subtitle': 'A U.S. private markets investment solutions provider',
    'companyIntro': 'Company Overview',
    'companyIntroP1': 'Hamilton Lane Inc is a U.S. provider of private markets investment solutions. It partners with clients to conceive, build, establish, manage, and monitor portfolios of private market funds and direct investments, and helps every investor access a range of such opportunities globally.',
    'companyIntroP2': 'The company offers investment solutions across a range of private markets. As a professional investment platform built for high-net-worth clients, we remain committed to delivering quality service and quality investment opportunities.',
    'statYears': 'Private Markets Focus',
    'statClients': 'Clients Served',
    'statCountries': 'Markets Covered',
    'statEmployees': 'Specialist Team',
    'ourMission': 'Our Mission',
    'missionInnovation': 'Professional Solutions',
    'missionInnovationDesc': 'Deliver institutional-grade private market fund and direct investment solutions',
    'missionPartnership': 'Client Partnership',
    'missionPartnershipDesc': 'Build and manage portfolios side by side with clients from conception to monitoring',
    'missionGlobalImpact': 'Global Access',
    'missionGlobalImpactDesc': 'Help every investor reach private market opportunities worldwide',
    'ourServices': 'Our Services',
    'serviceAI': 'Portfolio Conception',
    'serviceAIDesc': 'Co-design objectives and strategies for private market allocation',
    'serviceBlockchain': 'Funds & Direct Deals',
    'serviceBlockchainDesc': 'Structure private market funds and construct direct investment portfolios',
    'serviceCloud': 'Portfolio Management',
    'serviceCloudDesc': 'Continuously manage holdings with performance tracking and refinement',
    'serviceData': 'Risk Monitoring',
    'serviceDataDesc': 'Monitor risk with disciplined processes for transparency and control'
  },

  notFound: {
    'title': 'Pagina non trovata',
    'description': 'La pagina che stai cercando non esiste o e stata spostata.',
    'goHome': 'Vai alla Home',
    'goBack': 'Torna indietro'
  },

  translationTest: {
    'pageTitle': 'Test Traduzione',
    'currentLanguage': 'Lingua attuale',
    'selectLanguage': 'Seleziona lingua',
    'balanceInsufficient': 'Saldo insufficiente',
    'fundPasswordError': 'Password fondi errata',
    'submitFailed': 'Invio fallito',
    'pendingWithdrawal': 'Richiesta di prelievo in attesa',
    'langZh': 'Cinese',
    'langEn': 'Inglese',
    'langIt': 'Italiano',
    'langFr': 'Francese',
    'langDe': 'Tedesco',
    'langEs': 'Spagnolo',
    'langPt': 'Portoghese',
    'langPl': 'Polacco',
    'langTr': 'Turco',
    'mockTestTitle': 'Test messaggio errore simulato',
    'testFundPasswordError': 'Test traduzione password fondi',
    'testDirect': 'Test traduzione diretta',
    'original': 'Messaggio originale',
    'translated': 'Dopo traduzione',
    'direct': 'Traduzione diretta'
  },

  iconTest: {
    'pageTitle': 'Test Icone',
    'crypto': 'Crypto.com',
    'binance': 'Binance',
    'okx': 'OKX',
    'bitget': 'Bitget',
    'lbank': 'LBank',
    'kucoin': 'KuCoin',
    'kraken': 'Kraken',
    'gate': 'Gate.io',
    'upbit': 'Upbit',
    'bitfinex': 'Bitfinex',
    'bybit': 'Bybit',
    'huobi': 'Huobi',
    'coinbase': 'Coinbase',
    'default': 'Icona predefinita'
  },

  // ==================== Pagina Messaggi - Messages.vue ====================
  messages: {
    '站内信': 'Messaggi',
    'messageCenter': 'Centro Messaggi',
    'title': 'Messaggi',
    'total': 'Totale',
    'unread': 'Non letti',
    'statusNew': 'NUOVO',
    'statusRead': 'LETTO',
    'noDataAlt': 'Nessun dato',
    '暂无消息': 'Nessun Messaggio',
    '加载中': 'Caricamento...',
    '加载更多': 'Carica di Più',
    '删除': 'Elimina',
    '删除成功': 'Eliminato con Successo',
    '删除失败': 'Errore nell\'Eliminazione',
    '确定删除吗': 'Sei sicuro di voler eliminare?',
    '昨天': 'Ieri',
    'closeButton': 'Chiudi'
  },

  // ==================== Traduzioni Comuni ====================
  common: {
    '加载中': 'Caricamento...',
    '加载更多': 'Carica di Più',
    '删除': 'Elimina',
    '删除成功': 'Eliminato con Successo',
    '删除失败': 'Errore nell\'Eliminazione',
    '确定删除吗': 'Sei sicuro di voler eliminare?',
    '昨天': 'Ieri',
    '查看全部': 'Visualizza Tutto',
    '品牌名': 'HamiltonLane',
    '放款机构名称': 'HamiltonLane',
    '以太坊网络': 'Ethereum',
    '在线客服': 'Supporto online',
    '在线': 'Online',
    '输入消息...': 'Inserisci un messaggio...',
    '输入消息占位': 'Inserisci un messaggio...',
    '发送': 'Invia',
    '客服欢迎语': 'Ciao, questo e il supporto online. Come possiamo aiutarti?',
    '客服自动回复提现': 'Abbiamo ricevuto la tua richiesta di prelievo. Invia il numero ordine per verifica prioritaria.',
    '客服自动回复充值': 'Abbiamo ricevuto la tua richiesta di deposito. Invia valuta, rete e numero ordine.',
    '客服自动回复密码': 'Per sicurezza, non inviare la password fondi in chat. Ti guideremo con passaggi sicuri.',
    '客服自动回复默认': 'Abbiamo ricevuto il tuo messaggio. Il supporto lo sta elaborando, attendi un momento.',
    '仅支持图片文件': 'Sono supportati solo file immagine.',
    '图片大小不能超过5MB': 'La dimensione dell immagine non puo superare 5MB.'
  },

  // ==================== Pagina Whitepaper - Whitepaper.vue ====================
  whitepaper: {
    '白皮书': 'Whitepaper',
    '正在加载白皮书': 'Caricamento whitepaper',
    '加载失败': 'Caricamento fallito',
    '重试': 'Riprova',
    '在新窗口打开': 'Apri in nuova finestra',
    '下载PDF': 'Scarica PDF'
  },

  creditScore: {
    'pageTitle': 'Punteggio Credito',
    'overview': 'Panoramica Credito',
    'composition': 'Composizione Punteggio',
    'factorStability': 'Stabilita Account',
    'factorBehavior': 'Comportamento Fondi',
    'factorRisk': 'Storico Rischio',
    'adviceTitle': 'Consigli Credito',
    'tip1': 'Mantieni saldo stabile e attivita quotidiana per migliorare il punteggio.',
    'tip2': 'Riduci trasferimenti anomali e frequenti di grandi importi per diminuire il rischio.',
    'tip3': 'Completa le impostazioni di sicurezza per aumentare l affidabilita dell account.',
    'levelAPlus': 'A+ Eccellente',
    'levelA': 'A Stabile',
    'levelB': 'B Buono',
    'levelC': 'C Attenzione',
    'levelD': 'D Rischio'
  }

}
